/* The desktop app's line icons (desktop/assets/icons), inlined, in currentColor. */
const raw = import.meta.glob("./icons/*.svg", { query: "?raw", import: "default", eager: true }) as Record<string, string>;

const ICONS: Record<string, string> = {};
for (const [path, svg] of Object.entries(raw)) {
  const name = path.replace(/^.*\/(.*)\.svg$/, "$1");
  ICONS[name] = svg
    .replace(/stroke="#000"/g, 'stroke="currentColor"')
    .replace(/fill="#000"/g, 'fill="currentColor"')
    .replace(/ width="\d+" height="\d+"/, "");
}
const MARK = (import.meta.glob("../../public/app-mark.svg", { query: "?raw", import: "default", eager: true }) as Record<string, string>);
const markSvg = Object.values(MARK)[0]
  ?.replace(/stroke="#000"/g, 'stroke="currentColor"')
  .replace(/ width="\d+" height="\d+"/, "");

export function Icon({ name, size = 20, class: cls }: { name: string; size?: number; class?: string }) {
  const svg = name === "app-mark" ? markSvg : ICONS[name];
  return (
    <span
      class={`icon ${cls ?? ""}`}
      style={{ width: `${size}px`, height: `${size}px` }}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: svg ?? "" }}
    />
  );
}
